import dayjs from "dayjs";

export function sortProducts(products, criteria, order) {
  // Create a copy of the original array to avoid modifying it
  const sortedProducts = [...products];

  return sortedProducts.sort((a, b) => {
    let comparison = 0;

    if (criteria === "alphabetic") {
      comparison = a.name.localeCompare(b.name);
    } else if (criteria === "numeric") {
      comparison = parseInt(a.id) - parseInt(b.id);
    } else if (criteria === "price") {
      const priceA = parseInt(a.offerPrice.replace("₹ ", ""));
      const priceB = parseInt(b.offerPrice.replace("₹ ", ""));
      comparison = priceA - priceB;
    }

    return order === "asc" ? comparison : -comparison;
  });
}

export function linkToProduct(product) {
  const link_product = product?.name
    ?.split(" ")
    .join("-")
    .toLowerCase()
    .replace("%", "");
  return `/products/${link_product}`;
}
export function linkToBlog(blog) {
  const link_blog = blog?.headline
    ?.split(" ")
    .join("-")
    .toLowerCase()
    .replace("%", "");
  return `/pages/blogs/${link_blog}`;
}
export function linkToCollection(name) {
  const link_collection = name?.split(" ").join("-").toLowerCase();
  return `/collection/${link_collection}`;
}
export function frmatDateMonth(date) {
  const formattedDate = dayjs(date).format("MMM DD, YYYY");
  return formattedDate;
}
